import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0befc079&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=0befc079&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0befc079",
  null
  
)

export default component.exports